<template>
  <div>
    <el-card>
      <el-tabs v-model="queryForm.params.taskTab" class="tabs_style" @tab-click="handleClick">
        <el-tab-pane :label="$t('collectionCenter.todaysTasks') + ' (' + taskTabCount.today + ')'" name="today" />
        <el-tab-pane :label="$t('collectionCenter.historyRecords') + ' (' + taskTabCount.history + ')'" name="history" />
      </el-tabs>
      <el-table :data="tableData" border max-height="600">
        <el-table-column
          :label="$t('Resource.taskId')" align="center" prop="id"
          width="120"
        />
        <!-- 文档导出状态 -->
        <el-table-column
          :label="$t('Resource.taskType')" align="center" prop="type"
          width="100"
        >
          <template #default="scope">
            <el-tag v-if="scope.row.type === 1" type="success">{{ $t('Resource.import') }}</el-tag>
            <el-tag
              v-else-if="scope.row.type === 2" type="warning"
            >{{ $t('Resource.export') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('Resource.taskStatus')" align="center" prop="status"
          width="130"
        >
          <template slot-scope="scope">
            <!-- 状态：0-「排队中」,1-「导出中」,2-完成,3-失败-->
            <span v-if="scope.row.status === 0">
              <span class="tag_orange"><svg-icon icon-class="hourglass" />{{ $t('Resource.init') }}</span><!-- 排队中 -->
              <span class="tag_gray">{{ $t('collectionCenter.queueCount') }}：{{ scope.row.queueCount }}</span><!-- 排队个数 -->
            </span>
            <span v-else-if="scope.row.status === 1">
              <span class="el-icon-s-tools tag_blue">
                {{ $t('basicData.exporting') }}<!-- 导出中 -->
              </span>
            </span>
            <el-tag
              v-else-if="scope.row.status === 2" type="success"
            >{{ $t('Resource.complete') }}
            </el-tag>
            <el-tag
              v-else-if="scope.row.status === 3" type="danger"
            >{{ $t('Resource.fail') }}
            </el-tag>
            <span v-else-if="scope.row.status === 4">
              <span class="tag_gray">{{ $t('collectionCenter.cancelled') }}</span><!-- 已取消 -->
            </span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('Resource.schedule')" align="center" prop="schedule"
          width="180"
        >
          <template slot-scope="scope">
            <el-progress
              :percentage="scope.row.schedule"
              :status="
                scope.row.schedule == 100 ? 'success' : scope.row.status === 3 ? 'exception' : ''
              "
            />
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('Resource.total')"
          align="center"
          prop="estimateCount"
          width="190"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.status == 2">
              {{ scope.row.successCount }}
            </div>
            <div v-else>
              {{ scope.row.estimateCount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('Resource.fileName')"
          align="center"
          prop="fileName"
          width="220"
        />
        <el-table-column
          :label="$t('Resource.failedMessage')"
          align="center"
          prop="failedMessage"
          show-overflow-tooltip
          width="200"
        />
        <el-table-column
          :label="$t('Resource.operator')"
          align="center"
          prop="createUsername"
          width="150"
        />
        <el-table-column
          :label="$t('Resource.startTime')"
          align="center"
          prop="startTime"
          width="200"
        />
        <el-table-column
          :label="$t('Resource.endTime')" align="center" prop="endTime"
          width="200"
        />
        <el-table-column
          :label="$t('operationCenter.operate')"
          align="center"
          fixed="right"
          prop="operation"
          width="120"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.fileUrl">
              <el-button
                size="mini" type="info" @click="handleDownload(scope.row.fileUrl)"
              >{{ $t('Resource.download') }}
              </el-button>
            </div>
            <div v-if="scope.row.status === 0 || scope.row.status === 1">
              <el-button
                size="mini" type="danger" plain
                @click="cancelTaskClick(scope.row)"
              >{{ $t('collectionCenter.cancelTask') }}
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <!-- 分页工具 -->
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @current-change="getData"
          @size-change="getData(1)"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { apiFileTaskPage, cancelFileTask } from '@/api/resources';
import { setHttpTurnHttps } from '@/utils/tools';

export default {
  data() {
    return {
      interval: null,
      total: 0,
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          fileName: '',
          taskTab: 'today'
        }
      },
      tableData: [],
      taskTabCount: {
        history: 0,
        today: 0
      }
    };
  },

  created() {
    this.queryForm.params.taskTab = 'today';
    this.getData();
  },
  mounted() {
    this.interval = setInterval(() => {
      this.getData();
    }, 10 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
    this.interval = null;
  },
  methods: {
    handleClick() {
      this.queryForm.pageNumber = 1;
      this.getData();
    },
    cancelTaskClick(row) {
      cancelFileTask(row.id).then((res) => {
        if (res.code === 200) {
          this.$message.success(this.$t('collectionCenter.cancelled'));
          this.getData();
        }
      });
    },
    getData(num = null) {
      if (num === 1) {
        this.queryForm.pageNumber = 1;
      }
      apiFileTaskPage(this.queryForm)
        .then((res) => {
          if (res.code === 200) {
            const { records, total, taskTabCount } = res.data;
            this.taskTabCount = taskTabCount;
            this.total = total;
            this.tableData = records.map((item, index) => {
              if (item.fileUrl) {
                item.newFileUrl = item.fileUrl;
              }
              // 进度条
              const schedule = item.estimateCount
                ? (item.successCount / item.estimateCount) * 100
                : 0;
              if (schedule > 100) {
                item.schedule = 100;
              } else {
                item.schedule = Number(schedule.toFixed(1));
              }
              if (item.fileUrl != null) {
                item.schedule = 100;
                item.status = 2;
              }
              if (item.successCount === 0 && item.totalCount === 0 && item.status === 2) {
                item.schedule = 100;
              }
              if (item.isFailed) {
                item.status = 3;
              }
              return {
                ...item
              };
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    /**
     * 文件下载
     */
    handleDownload(url) {
      if (url === 'ok') {
        this.$message({
          // '导入成功无错误数据'
          message: this.$t('Resource.importSuccessNotErr'),
          type: 'warning'
        });
        return;
      }
      if (url.length) {
        const a = document.createElement('a');
        a.href = setHttpTurnHttps(url);
        a.click();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.app-container {
  padding: 20px;
  box-sizing: border-box;
}
.app-container ::v-deep .el-table__cell { background: #fff; }
.tabs_style ::v-deep .el-tabs__item.is-active { color: #42b983 !important; }
.tabs_style ::v-deep .el-tabs__active-bar { background-color: #42b983 !important; }
.tag_orange { color: #fc902c; display: flex;justify-content: center;align-items: center; }
.tag_orange ::v-deep .svg-icon { width: 1em !important; height: 1em !important;margin-right: 8px; }
.tag_gray { color: #7f7f7f; }
.tag_blue { color: #2284fc;}

.mr10 {
  margin-right: 10px;
}

.putAway {
  position: absolute;
  right: 0;
  top: 0;
  color: #1989fa;
  cursor: pointer;
  z-index: 100;
}
</style>
